import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

function ChildVaccinationForm() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    childId: '',
    vaccineId: '',
    administeredDate: '',
    administeredBy: '',
    nextDueDate: '',
    notes: '',
    apiType: 'vaccinations'
  });

  const [vaccines] = useState([
    { vaccine_id: 1, vaccine_name: 'DTP' },
    { vaccine_id: 2, vaccine_name: 'MMR' }
  ]);

  const [staff] = useState([
    { staff_id: 1, first_name: 'Dr.', last_name: 'Smith' },
    { staff_id: 2, first_name: 'Nurse', last_name: 'Johnson' }
  ]);

  const [errors, setErrors] = useState({
    childId: false,
    vaccineId: false,
    administeredDate: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      childId: !formData.childId,
      vaccineId: !formData.vaccineId,
      administeredDate: !formData.administeredDate
    };
    
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) return;

    try {
      await handleAPICall(formData);
      // Reset form after successful submission
      setFormData({
        childId: '',
        vaccineId: '',
        administeredDate: '',
        administeredBy: '',
        nextDueDate: '',
        notes: '',
        apiType: 'vaccinations'
      });
    } catch (error) {
      console.error('Vaccination record failed:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="p-5 bg-white rounded-4 shadow-lg mt-5"
      style={{ maxWidth: '', margin: '0 auto' }}
    >
      <h2 className="mb-5 text-primary text-center fw-bold">Child Vaccination Record</h2>

      <div className="row g-4 mb-4">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Child *</label>
            <select
              name="childId"
              value={formData.childId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.childId ? 'is-invalid' : ''}`}
            >
              <option value="">Select Child</option>
              <option value="1">Child 1</option>
              <option value="2">Child 2</option>
            </select>
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Vaccine *</label>
            <select
              name="vaccineId"
              value={formData.vaccineId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.vaccineId ? 'is-invalid' : ''}`}
            >
              <option value="">Select Vaccine</option>
              {vaccines.map(vaccine => (
                <option key={vaccine.vaccine_id} value={vaccine.vaccine_id}>
                  {vaccine.vaccine_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Date Administered *</label>
            <input
              type="date"
              name="administeredDate"
              value={formData.administeredDate}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.administeredDate ? 'is-invalid' : ''}`}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Administered By *</label>
            <select
              name="administeredBy"
              value={formData.administeredBy}
              onChange={handleChange}
              className="form-select border-bottom border-light py-2 w-100"
            >
              <option value="">Select Staff</option>
              {staff.map(s => (
                <option key={s.staff_id} value={s.staff_id}>
                  {s.first_name} {s.last_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Next Due Date</label>
            <input
              type="date"
              name="nextDueDate"
              value={formData.nextDueDate}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Notes</label>
            <input
              type="text"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
              placeholder="Additional notes..."
            />
          </div>
        </div>
      </div>

      <div className="d-grid mt-5">
        <button 
          type="submit"
          className="btn btn-primary btn-lg py-3 fw-bold hover-effect w-100"
          disabled={!formData.childId || !formData.vaccineId || !formData.administeredDate}
        >
          Record Vaccination
        </button>
      </div>
    </form>
  );
}

export default ChildVaccinationForm;